import { render } from "./UluslararasiSertifikalar.vue?vue&type=template&id=4c96562d&scoped=true"
import script from "./UluslararasiSertifikalar.vue?vue&type=script&lang=js"
export * from "./UluslararasiSertifikalar.vue?vue&type=script&lang=js"

import "./UluslararasiSertifikalar.vue?vue&type=style&index=0&id=4c96562d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c96562d"]])

export default __exports__